<app-icon class="warning-icon" hoverColor="system-amber" color="system-amber">warning</app-icon>
